<template>
  <div>
    <v-btn color="primary" dark class="mb-2 hbtn" to="/lost_and_found/store">{{ $t("communication.lostAndFound.new") }}</v-btn>
    <DataTable ref="reserDataTable" :disableSearch="true" :sortable="false" :url="'lost_and_found'" :titles="titles"
      :fields-hidden-main="['created_at', 'updated_at', 'deleted_at', 'captain_id']"
      :title="$t('communication.lostAndFound.tableTitle')" :enableEdit="false" :enableAdd="false" :enableDelete="false" :formatter="formatter"
      :actions-extra-main="actionsExtraMain" />
  </div>
</template>

<style>
.hbtn {
  float: right;
  z-index: 1;
  margin-top: 20px;
  margin-right: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";

const required = (val) =>
  (val !== null && val !== undefined) || "this field is required";

export default {
  name: "Lost And Found",
  title() {
    return this.$t("communication.lostAndFound.title");
  },
  components: { DataTable },
  data() {
    return {};
  },

  computed: {
    rules() {
      return {
        name: [required],
      };
    },
    formatter() {
      return {
        found: (value) => {
          if (value) {
            return `<span style="color: green">${this.$t("common.yes")}</span>`;
          }
          return `<span style="color: red">${this.$t("common.no")}</span>`;
        }
      }
    },
    titles() {
      return {
        id: this.$t("communication.lostAndFound.id"),
        object: this.$t("communication.lostAndFound.object"),
        day: this.$t("communication.lostAndFound.day"),
        start_time: this.$t("communication.lostAndFound.startTime"),
        end_time: this.$t("communication.lostAndFound.endTime"),
        createdBy: this.$t("communication.lostAndFound.createdBy"),
        passenger_number: this.$t("communication.lostAndFound.passengerNumber"),
        captain_username: this.$t("communication.lostAndFound.captain"),
        end_time: this.$t("communication.lostAndFound.endTime"),
        message: this.$t("communication.lostAndFound.message"),
        found: this.$t("communication.lostAndFound.found"),
      };
    },
    actionsExtraMain() {
      return {
        edit: {
          title: this.$t("common.edit"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "edit_lost_and_found",
              params: { id: item.id },
            }),
        },
        sendReminder: {
          title: this.$t("communication.lostAndFound.sendReminder"),
          icon: "message",
          action: ({ id }) => {
            this.sendMessage(id)
          },
        },
        delete: {
          title: this.$t("common.delete"),
          icon: "delete_forever",
          action: ({ id }) => {
            this.deleteLostAndFound(id)
          },
        },
      };
    },
  },
  methods: {
    deleteLostAndFound(id) {
      this.$dialova({
        title: this.$t("communication.lostAndFound.deletingItem", { id }),
        paragraph: this.$t("communication.lostAndFound.deleteConfirm", { id }),
        loader: true,
      })
        .then(({ close }) => {

          this.axios
            .delete(`lost_and_found/${id}`)
            .then((res) => {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("communication.lostAndFound.deletedSuccessfully"),
                "green"
              );
              this.$refs.reserDataTable.getData();
            })
            .catch((err) => {
              let response = err.response;
              if (response) {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  response.data.message,
                  "red"
                );
              } else {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("communication.lostAndFound.somethingWentWrong"),
                  "red"
                );
              }
            })
            .finally(() => (close()));
        })
        .catch(() => {
          console.log("cancelled");
        });
    },

    sendMessage(id) {
      this.$dialova({
        title: this.$t("communication.lostAndFound.sendingReminder", { id }),
        paragraph: this.$t("communication.lostAndFound.sendReminderConfirm", { id }),
        loader: true,
      })
        .then(({ close }) => {

          this.axios
            .post(`lost_and_found_message`,{id})
            .then((res) => {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("communication.lostAndFound.sentSuccessfully"),
                "green"
              );
            })
            .catch((err) => {
              let response = err.response;
              if (response) {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  response.data.message,
                  "red"
                );
              } else {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("communication.lostAndFound.somethingWentWrong"),
                  "red"
                );
              }
            })
            .finally(() => (close()));
        })
        .catch(() => {
          console.log("cancelled");
        });
    },
  }
};
</script>
